import React from 'react'
import { Toast } from 'primereact/toast'

export const Growl = () => (
  <Toast ref={(el) => { window.growl = el }} position='top-left' />
)
